import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import RowActionsMenu from '../../../common/table/row-actions-menu';
import getRowActions from './table-hac-row-actions';
import { getRowSurveyStatus } from '../domain/table-hac.utils';
import UpdateIndicator from '../../../../atoms/update-indicator';

function TableHacRow({ row, t, navigate }) {
  const surveyStatus = getRowSurveyStatus(row);

  return (
    <TableRow>
      <TableCell align="left">
        <span className="text">{row.name}</span>
      </TableCell>

      <TableCell align="left">
        <span className="text">{row.last_name}</span>
      </TableCell>

      <TableCell align="left">
        <span className="text">
          {row.prefix_phone} {row.phone}
        </span>
      </TableCell>

      <TableCell align="left">
        <span className="text">{row.retailer_name}</span>
      </TableCell>

      <TableCell align="left">
        <span className="text">{t(`countries-${row.area_code}`)}</span>
      </TableCell>

      <TableCell align="left">
        <span className="text">
          {row.pma_type === 1 ? t('common-primary') : row.pma_type === 2 ? t('common-secondary') : ''}
        </span>
      </TableCell>

      <TableCell align="center">
        <Tooltip
          title={surveyStatus.label}
          arrow
          placement="top"
          slotProps={{ popper: { disablePortal: true } }}
        >
          <span className="text">
            <span className={`survey ${surveyStatus.className}`}></span>
          </span>
        </Tooltip>
      </TableCell>

      <TableCell align="left">
        <span className="text last-update">
          {row.last_update}
          {row.notification === true && <UpdateIndicator />}
        </span>
      </TableCell>

      <TableCell align="right">
        <RowActionsMenu actions={getRowActions(row, t, navigate)} />
      </TableCell>
    </TableRow>
  );
}

export default TableHacRow;
